/**
 * Faixas de volume para compra antecipada de chaves/senhas.
 * Os percentuais são placeholders — ajuste conforme regra comercial da assistência.
 */
export const VOLUME_DISCOUNT_TIERS = [
  {
    quantity: 50,
    volumeDiscountPercent: 0,
    label: '50 chaves',
    description: 'Pacote inicial',
  },
  {
    quantity: 100,
    volumeDiscountPercent: 5,
    label: '100 chaves',
    description: 'Desconto por volume',
  },
  {
    quantity: 500,
    volumeDiscountPercent: 10,
    label: '500 chaves',
    description: 'Desconto intermediário',
  },
  {
    quantity: 1000,
    volumeDiscountPercent: 15,
    label: '1000 chaves',
    description: 'Maior desconto por volume',
  },
];

/**
 * Desconto adicional por pagamento antecipado (antecipação).
 * months = meses de crédito comprados à frente.
 */
export const ADVANCE_PAYMENT_OPTIONS = [
  {
    id: 'avista',
    months: 1,
    advanceDiscountPercent: 0,
    label: 'À vista (sem antecipação)',
  },
  {
    id: '3m',
    months: 3,
    advanceDiscountPercent: 3,
    label: '3 meses antecipados',
  },
  {
    id: '6m',
    months: 6,
    advanceDiscountPercent: 5,
    label: '6 meses antecipados',
  },
  {
    id: '12m',
    months: 12,
    advanceDiscountPercent: 10,
    label: '12 meses antecipados',
  },
];

export const CUSTOM_QUANTITY_OPTION = 'custom';
